import { ClbHeader } from "@celebration/react";
import HeaderBrand from "./HeaderBrand";
import HeaderButtons from "./HeaderButtons";

const Header: React.FC = () => (
  <ClbHeader>
    <HeaderBrand />
    <HeaderButtons />
  </ClbHeader>
);

export default Header;
